import {
  Component,
  Input,
  OnInit,
  AfterViewInit,
  Pipe,
  PipeTransform,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { first } from "rxjs/operators";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { GestionFichierService } from "src/app/core/services/business/service/gestion-fichier.service";

@Component({
  selector: "app-image-viewer-modal",
  templateUrl: "./image-viewer-modal.component.html",
  styleUrls: ["./image-viewer-modal.component.scss"],
})
export class ImageViewerModalComponent implements OnInit {
  destination: any;
  url: any[] = [];

  @Input() subitemId;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
    private sanitizer: DomSanitizer,
    private el: ElementRef,
    private _gestionFichierService: GestionFichierService
  ) {}

  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  ngOnInit() {
    this.downloadFile(this.subitemId);
  }

  downloadFile(id) {
    this._gestionFichierService.downloadBase64(id).subscribe(
      (data) => {
        this.destination = data.split("base64,", 2)[1];
        this.url.push(this.destination);
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
